export enum MessageType {
  USER_MESSAGE = 'USER_MESSAGE',
  WANT_LIST_REMINDER = 'WANT_LIST_REMINDER',
  EMAIL_VERIFICATION_REMINDER = 'EMAIL_VERIFICATION_REMINDER',
  PHONE_VERIFICATION_REMINDER = 'PHONE_VERIFICATION_REMINDER',
  TRADE_REMINDER_SHIP = 'TRADE_REMINDER_SHIP',
  TRADE_REMINDER_COMPLETE = 'TRADE_REMINDER_COMPLETE'
}

export interface Message {
  id: string;
  sender: {
    id: number;
    username: string;
    avatarUrl?: string;
  } | null;
  content: string;
  createdAt: string;
  isRead: boolean;
  type?: MessageType;
  isSystemMessage?: boolean;
}

export interface Conversation {
  conversationId: string;
  otherUser: {
    id: number;
    username: string;
    avatarUrl?: string;
  };
  lastMessage: string;
  lastMessageAt: string;
  unreadCount: number;
  isRead: boolean;
}

export interface InboxResponse {
  conversations: Conversation[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    hasMore: boolean;
  };
}

export interface ConversationThread {
  conversationId: string;
  otherUser: {
    id: number;
    username: string;
    avatarUrl?: string;
  };
  messages: Message[];
}

export interface NotificationSettings {
  emailOnNewMessage: boolean;
  emailOnNewTrade: boolean;
  emailOnSystemMessage: boolean;
}
